import { useRouter } from '@tanstack/react-router';

import { usePanelToggle } from '@/features/nav-rail/nav-rail.hooks';
import { useAppShortcut } from '@/features/shortcuts';
import { tabStore, useTabHotkeys } from '@/features/tabs';

import { useRegisterCopyNonEditableSelectionHotkey } from './useRegisterCopyNonEditableSelectionHotkey';
import { useRegisterGoToSettingsHotkey } from './useRegisterGoToSettingHotkey';
import { useRegisterNewChatHotkey } from './useRegisterNewChatHotkey';

// TODO: rename this to useRegisterAllHotkeys
export function useHotkeys() {
  useRegisterNewChatHotkey();
  useRegisterGoToSettingsHotkey();
  useRegisterCopyNonEditableSelectionHotkey();
  useRegisterSidebarHotkeys();
  useRegisterNavigationHotkeys();
  useTabHotkeys();
}

const useRegisterSidebarHotkeys = () => {
  const panelToggle = usePanelToggle();
  useAppShortcut('app.toggleSidebar', panelToggle.toggle, {
    ...hotkeyConfig,
    ignoreEventWhen: (e) => e.repeat,
  });
};

const useRegisterNavigationHotkeys = () => {
  const router = useRouter();

  useAppShortcut(
    'navigation.back',
    () => {
      const route = tabStore.goBack();
      if (route)
        router.navigate({
          to: route.path,
          search: route.search as Record<string, string>,
        });
    },
    hotkeyConfig
  );

  useAppShortcut(
    'navigation.forward',
    () => {
      const route = tabStore.goForward();
      if (route)
        router.navigate({
          to: route.path,
          search: route.search as Record<string, string>,
        });
    },
    hotkeyConfig
  );
};

export const hotkeyConfig = {
  preventDefault: true,
  enableOnFormTags: true,
  enableOnContentEditable: true,
};
